if (!customElements.get('g-brand-show')) {
  class MBrandShow extends HTMLElement {
    constructor() {
      super();
      this.duration = 1500;
      //控制程序什么时候执行
      this.isStop = this.dataset.animate === 'false';
      // 控制动画什么时候运动
      this.animated = true;
    }

    connectedCallback() {
      this.setupEventListeners();
      if (GkifyTheme.config.mqlMobile) {
        this.numberDoms = this.querySelectorAll('.js_number_animate_mobile');
      } else {
        this.numberDoms = this.querySelectorAll('.js_number_animate');
      }
      if (this.numberDoms.length === 0) return;
      this.numberDoms = Array.from(this.numberDoms);
      this.values = this.numberDoms.map((dom) => {
        let numberText = dom.textContent.trim();
        let number = parseFloat(numberText);
        let ext = numberText.slice(String(number).length);
        return {
          number,
          ext,
        };
      });
      const observer = new IntersectionObserver(
        (entry) => {
          if (entry[0].isIntersecting) {
            if (this.isStop) {
              return;
            }
            this.animated = true;
            this.execute.call(this);
          } else {
            this.animated = false;
            this.initNumber();
          }
        },
        { rootMargin: '0px' }
      );

      observer.observe(this);
    }
    initNumber() {
      this.numberDoms.forEach((dom, i) => {
        dom.textContent = this.values[i].number + this.values[i].ext;
      });
    }
    run() {
      this.isStop = false;
      this.animated = true;
      this.values = this.numberDoms.map((dom) => {
        let numberText = dom.textContent.trim();
        let number = parseFloat(numberText);
        let ext = numberText.slice(String(number).length);
        return {
          number,
          ext,
        };
      });
      this.execute.call(this);
    }
    execute() {
      for (const dom of this.numberDoms) {
        let numberText = dom.textContent.trim();
        let number = parseFloat(numberText);
        let ext = numberText.slice(String(number).length);
        const startTime = performance.now();
        if (Number.isNaN(number)) continue;
        let currentNumber = 0;
        function animate() {
          if (!this.animated) {
            this.initNumber();
            return;
          }
          const currentTime = performance.now();
          const elapsedTime = currentTime - startTime;
          const progress = elapsedTime / this.duration;

          if (progress < 1) {
            if (dom.dataset.float === 'true' && number > 0) {
              currentNumber = (progress * number).toFixed(2);
            } else {
              currentNumber = Math.floor(progress * number);
            }
            dom.textContent = `${currentNumber}${ext}`;
            requestAnimationFrame(animate.bind(this));
          } else {
            this.initNumber();
          }
        }

        requestAnimationFrame(animate.bind(this));
      }
    }

    setupEventListeners() {
      const withdrawalBtns = this.querySelectorAll('[data-withdrawal-modal]');
      const referralBtns = this.querySelectorAll('[data-referral-details]');
      const rewardBtns = this.querySelectorAll('[data-reward-modal]');
      const activitiesBtns = this.querySelectorAll('[data-activities-modal]');

      if (withdrawalBtns.length > 0) {
        withdrawalBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const withdrawalModal = document.querySelector('#withdrawalModal');
            if (withdrawalModal) {
              withdrawalModal.open();
            }
          });
        });
      }

      if (referralBtns.length > 0) {
        referralBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const referralHistoryModal = document.querySelector('#referralHistoryModal');
            if (referralHistoryModal) {
              referralHistoryModal.open();
            }
          });
        });
      }

      if (rewardBtns.length > 0) {
        rewardBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const rewardModal = document.querySelector('#my-reward-list-modal');
            if (rewardModal) {
              rewardModal.open();
            }
          });
        });
      }

      if (activitiesBtns.length > 0) {
        activitiesBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const activitiesModal = document.querySelector('#my-activities-list-modal');
            if (activitiesModal) {
              activitiesModal.open();
            }
          });
        });
      }
    }
  }

  customElements.define('g-brand-show', MBrandShow);
}
